//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MButton from "./MButton";
import vClickOutside from "v-click-outside";
const { utils, requests, store } = window.MattingEngineModule;
const openFile = utils.openFile;
function normalizeNum(data, base = 4, item = null) {
  const diffNum = base - (data.length % base);
  if (diffNum)
    return [...data, ...Array.apply(null, { length: diffNum }).map(() => item)];
}

export default {
  name: "MattingBgReplacement",
  components: {
    MButton,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      state: "colors",
      selectedObj: "",
      colors: [],
      partialImages: [],
      moreImages: [],
      selectedImages: {},
      isShowMoreImages: false,
      tabIndex: 0,
      imgIndex: null,
    };
  },
  computed: {
    isShowColors() {
      return this.state === "colors";
    },
    isShowImages() {
      return this.state === "images";
    },
    moreActive() {
      return this.moreImages.includes(this.selectedImages);
    },
  },
  created() {
    this.getColors();
    this.getCategories().then(() => {
      this.selectedImages = this.partialImages[0];
    });
  },
  mounted() {
    this.$nextTick(() => {
      store.canvasManager.registeReset(() => {
        (this.tabIndex = 0), (this.imgIndex = null);
      });
    });
  },
  methods: {
    drawColors(colorVal, index) {
      this.tabIndex = index;
      this.imgIndex = null;
      store.advancedManager.drawColors(colorVal);
    },
    drawImage(url, index) {
      this.imgIndex = index;
      this.tabIndex = null;
      store.advancedManager.drawImage(url);
    },
    showColors() {
      this.state = "colors";
    },
    showImages() {
      this.state = "images";
    },
    selectImages(image) {
      this.selectedImages = image;
      if (image.done) return;
      const placeholder = Array.apply(null, { length: 4 }).map(
        () => "data:;,x"
      );
      this.$set(image, "data", placeholder);
      this.getImagesById(image.id).then((data) => {
        this.$set(
          image,
          "data",
          data.map((obj) => obj.url)
        );
        image.done = true;
      });
    },
    getColors() {
      this.colors = normalizeNum([
        "transparent",
        "#ffffff",
        "#000000",
        "#9A0012",
        "#D53D0F",
        "#FD9800",
        "#FFDBA4",
        "#FEC107",
        "#FFEB3C",
        "#A2D791",
        "#8BC24A",
        "#4CA150",
        "#009788",
        "#69AFF6",
        "#2274E4",
        "#004797",
        "#6976F6",
        "#4B3FB5",
        "#2B008D",
        "#B6A1CF",
        "#7E46F6",
        "#522AAD",
        "#EAEAEA",
        "#9D9D9D",
      ]);
    },
    getCategories() {
      const detectLanguage = this.$root.detectLanguage;
      let lang = detectLanguage ? detectLanguage() : "zh_CN";
      return requests
        .getCategories({
          params: { lang, type: "background" },
        })
        .then((res) => {
          let data = [
            { id: "my", title: this.$t("Matting.my"), data: [], done: true },
            ...res.data,
          ];
          this.myImages = data[0];
          this.partialImages = data.slice(0, 4);
          this.moreImages = data.slice(4);
        });
    },
    getImagesById(id) {
      return requests
        .getBackgroundImages({
          params: {
            theme: id,
          },
        })
        .then((res) => {
          let data = res.data;
          data = normalizeNum(data, 4, { url: "" });
          return data;
        });
    },
    useMyImage() {
      const self = this;
      openFile(function (files) {
        const file = files[0];
        const fileReader = new FileReader();
        fileReader.onload = function (evt) {
          const result = evt.target.result;
          self.myImages.data = self.myImages.data.filter((url) => !!url);
          self.myImages.data.push(result);
          let length = self.myImages.data.length;
          self.myImages.data = normalizeNum(self.myImages.data, 4, "");
          self.drawImage(result, length - 1);
        };
        fileReader.readAsDataURL(file);
      });
    },
  },
};
